import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src509251388/src/skop-manage/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["toast","success","error","warning","info","loading","dismiss","Toaster"] */ "/codebuild/output/src509251388/src/skop-manage/node_modules/sonner/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src509251388/src/skop-manage/src/components/providers/BugsnagInit.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PostHogProvider"] */ "/codebuild/output/src509251388/src/skop-manage/src/context/PostHogProvider.tsx");
